export default "__VITE_ASSET__f1a92fd4__"